import { AxisSwitcher, Button, Col, H3, Hidden, P, ProductTile, Row, SpacerWrapper, TypeWrapper } from '@ahmdigital/ui';
import { get, map } from 'lodash/fp';

import { ProductType } from '../../../../../types/product';
import buildFinancialProductItemListSchema from '../../../../../components/structured-data/utils/build-financial-product-item-list-schema';
import buildFinancialProductSchema from '../../../../../components/structured-data/utils/build-financial-product-schema';
import buildFinancialProductSourceFromRuntime from '../../../../../components/structured-data/utils/build-financial-product-source-from-runtime';
import constants from '../../../../../ahm-constants';
import PriceDisclaimer from '../../../../../components/price-disclaimer';
import StructuredData from '../../../../../components/structured-data';
import styles from './styles.module.sass';

type ProductsSectionProps = {
  isLoadingPrice?: boolean;
  mlsAmount?: number;
  products: ProductType[];
};

const ProductsSection = ({ isLoadingPrice = false, mlsAmount = 0, products }: ProductsSectionProps) => {
  const financialProductSchemas = products.map((product) =>
    buildFinancialProductSchema(
      buildFinancialProductSourceFromRuntime({
        product: product as ProductType,
      }),
    ),
  );

  const financialProductItemListSchema = buildFinancialProductItemListSchema(financialProductSchemas);

  return (
    <>
      <StructuredData data={financialProductItemListSchema} />
      <SpacerWrapper variant={styles.wrapper}>
        <Row>
          <Col df={12} variant="marginBottomSpacer9">
            <TypeWrapper variant="center">
              {mlsAmount > 0 ? (
                <H3>Here are some ahm products that might help with tax</H3>
              ) : (
                <>
                  <H3>Having hospital cover is still a great idea.</H3>
                  <P looksLike="h3" variant="regular">
                    Get started with…
                  </P>
                </>
              )}
            </TypeWrapper>
          </Col>
        </Row>
        <div className={styles.productTiles}>
          <AxisSwitcher limit={3} space="1rem" threshold="40rem">
            {map(
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'url' does not exist on type 'ProductType'.
              ({ content, url, ...restOfProps }) => (
                <div className={styles.productTileWrapper} key={url}>
                  {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ ctaVariant: string[]; isLoadingPrice: boolean | undefined; key: any; linkTo: any; blurb: any; variant: string | undefined; }' is missing the following properties from type 'Pick<Pick<ProductTileProps, keyof ProductTileProps> & Pick<InferProps<{ ctaVariant: Requireable<NonNullable<string | object | null | undefined>>; variant: Requireable<...>; }>, "ctaVariant"> & Pick<...>, "name" | ... 3 more ... | "ctavariant">': name, type, id, frequency */}
                  <ProductTile
                    {...restOfProps}
                    ctaVariant={['white', 'border']}
                    isLoadingPrice={isLoadingPrice}
                    key={url}
                    linkTo={url}
                    blurb={get('longForm', content)}
                    variant={styles.productTile}
                  />
                </div>
              ),
              products,
            )}
          </AxisSwitcher>
        </div>

        <Row>
          <Col df={12} variant={styles.buttonWrapper}>
            <Button to={constants.URLS.SALES.PRODUCT_LISTING_HOSPITAL} variant={styles.cta}>
              Compare covers
            </Button>
          </Col>

          <Col df={12} variant="marginBottomSpacer8">
            <div className={styles.disclaimerContainer}>
              <PriceDisclaimer bold showRefineLink constrainWidth forProducts={products} center />
            </div>
          </Col>
          <Col df={12} variant={styles.buttonWrapper}>
            <Hidden xs>
              <span className={styles.or}>Also interested in extras cover?</span>
            </Hidden>
            <Button to={constants.URLS.SALES.CHOOSE_YOUR_COVER_COMBINED_CHOOSE} variant={['border', 'white']}>
              View hospital & extras cover
            </Button>
          </Col>
        </Row>
      </SpacerWrapper>
    </>
  );
};

export default ProductsSection;
